import { render, staticRenderFns } from "./QuizEdit.vue?vue&type=template&id=7dfc72df&scoped=true&"
import script from "./QuizEdit.vue?vue&type=script&lang=js&"
export * from "./QuizEdit.vue?vue&type=script&lang=js&"
import style0 from "./QuizEdit.vue?vue&type=style&index=0&id=7dfc72df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfc72df",
  null
  
)

export default component.exports